// InfoTooltip — Product Tours descoped for R1.
// Stub retained because InfoTooltip is used across dashboard cards.
// Renders nothing — tooltip behaviour removed with tours feature.

interface InfoTooltipProps {
  title?: string;
  content?: string;
  [key: string]: unknown;
}

export function InfoTooltip(_props: InfoTooltipProps): null {
  return null;
}
